import { http } from '../../services/http';
import { reactLocalStorage } from 'reactjs-localstorage';

export const getAccessoriesListShop = () => {
  return dispatch => {
    http
      .post(`/furniture/data/accessories`, { all: true })
      .then(response => {
        dispatch({
          type: 'GET_ACCESSORIES_LIST_SHOP_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_ACCESSORIES_LIST_SHOP_ERROR', data: err });
      });
  };
};

export const getAccessories = (safo, width, depth) => {
  return dispatch => {
    http
      .post(`/furniture/data/accessories`, {
        safo: safo,
        width: width,
        depth: depth,
        height: reactLocalStorage.get('wardrobeHeight', 240),
      })
      .then(response => {
        dispatch({
          type: 'GET_ACCESSORIES_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_ACCESSORIES_ERROR', data: err });
      });
  };
};

export const getDedicatedAccessories = safo => {
  return dispatch => {
    http
      .post(`/furniture/data/dedicated`, { safo })
      .then(response => {
        dispatch({
          type: 'GET_DEDICATED_ACCESSORIES_SUCCESS',
          data: response.data.result,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_DEDICATED_ACCESSORIES_ERROR', data: err });
      });
  };
};
